<template>
    <div class="add_new_store_wrap">
        <section class="breadcrumb-section mt_20">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">
                            My Account
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="myorder_section pt-0 pb-0 manage_payment">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="dashboard_design d-md-flex mb_82">
                            <div class="side_bar px-0 sidebar_desk">
                                <ul class="side_bar_links mt_2 p-0">
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/myorder.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Orders</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/saved_design.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Saved Designs</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/upload_img.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Uploaded Images</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/payement.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Payment Options</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/fav.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Favorite</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/edit_profile.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Edit Profile</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class="active"
                                            ><img
                                                src="/maincss/images/mystore.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Store</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_payment.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Player</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_team.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Team</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/logout.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Logout</a
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div class="sidebar_mobile">
                                <a class="dropdown-toggle" id="item2" href="#"
                                    >My Account</a
                                >
                                <div class="side_bar px-0">
                                    <ul
                                        id="submenu2"
                                        class="side_bar_links mt_2 p-0 dropdown"
                                    >
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/myorder.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Orders</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/saved_design.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Saved Designs</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/upload_img.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Uploaded Images</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/payement.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Payment Options</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/fav.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Favorite</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/edit_profile.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Edit Profile</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class="active"
                                                ><img
                                                    src="/maincss/images/mystore.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Store</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_payment.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Player</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_team.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Team</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/logout.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Logout</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="left_panel">
                                <div class="row checkout_wizard">
                                    <div class="col-lg-3">
                                        <h2
                                            class="font_size_20 font-weight-bold mb-0 text_black"
                                        >
                                            Add Product
                                        </h2>
                                    </div>
                                    <div class="col-lg-6">
                                        <div
                                            class="wizard d-flex justify-content-center align-items-center"
                                        >
                                            <div
                                                class="field d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    class="circle mr_10 d-none"
                                                >
                                                    1
                                                </div>
                                                <div
                                                    class="circle mr_10 bg_primary_blue"
                                                >
                                                    <img
                                                        src="/maincss/images/icons/right_tick.svg"
                                                    />
                                                </div>
                                                <h5 class="mb-0">
                                                    Store Details
                                                </h5>
                                            </div>
                                            <div class="devider"></div>
                                            <div
                                                class="field d-flex justify-content-center align-items-center"
                                            >
                                                <div class="circle mr_10">
                                                    2
                                                </div>
                                                <h5 class="mb-0">
                                                    Add Products
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 accordian_with_form">
                                        <div class="accordion mt_36">
                                            <div class="card add_product_card">
                                                <div class="card-header p-0">
                                                    <h2
                                                        class="mb-0 accordian_heading text-left d-flex"
                                                        data-toggle="collapse"
                                                        data-target="#collapseOne"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                    >
                                                        Store Details
                                                    </h2>
                                                </div>
                                                <div
                                                    id="collapseOne"
                                                    class="collapse show"
                                                    aria-labelledby="headingOne"
                                                    data-parent="#accordionExample"
                                                >
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div
                                                                class="col-md-12 col-lg-6"
                                                            >
                                                                <div
                                                                    class="form-group"
                                                                >
                                                                    <label
                                                                        >Select
                                                                        Catagory</label
                                                                    >
                                                                    <span
                                                                        class="highlight"
                                                                    ></span>
                                                                    <select
                                                                        class="form-control bg-transparent"
                                                                    >
                                                                        <option>
                                                                            Select
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-md-12 col-lg-6"
                                                            >
                                                                <div
                                                                    class="form-group"
                                                                >
                                                                    <label
                                                                        >Select
                                                                        Sub
                                                                        Catagory</label
                                                                    >
                                                                    <span
                                                                        class="highlight"
                                                                    ></span>
                                                                    <select
                                                                        class="form-control bg-transparent"
                                                                    >
                                                                        <option>
                                                                            Select
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-center mt_60">
                                        <a href="#">
                                            <span class="ml-auto my-auto plus"
                                                ><img
                                                    src="/maincss/images/plus.svg"
                                                    alt=" "
                                            /></span>
                                            <span
                                                class="add_cat font_size_18 text_primary_blue ml_14 pt_2"
                                                >Add Other Category</span
                                            >
                                        </a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div
                                            class="add_product_btns buttons ml-auto text-center text-md-right"
                                        >
                                            <a
                                                href="#"
                                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_22 px_80 mr_34"
                                                >Cancel</a
                                            >
                                            <a
                                                href="#"
                                                class="btn-desable btn btn_orange bg_primary_orange text_white py_22 px_80"
                                                >ADD</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "AddProduct",
    components: {},
    mounted() {
        // document.body.classList.add('bg_primary_light_white');
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    }
};
</script>
